define([
	'internal_util/Util',
	'model/Image'
], function (
	Util,
	Image
) {
	'use strict';

	return function (name, url, description, image, privacyStatement, poweredByImage) {
		var _name,
			_url,
			_description = null,
			_image = null,
			_poweredByImage = null,
			_privacyStatement = null;

		if (Util.isValidString(name)) {
			_name = name;
		} else {
			throw new Error('invalid provider name: ' + name);
		}

		if (Util.isValidURL(url)) {
			_url = url;
		} else {
			throw new Error('invalid provider url: ' + url);
		}

		if (Util.isValidString(description)) {
			_description = description;
		} else {
			throw new Error('invalid provider description:' + description);
		}

		if (image instanceof Image) {
			_image = image;
		} else {
			throw new Error('invalid provider image: ' + image);
		}
		
		if (poweredByImage instanceof Image) {
			_poweredByImage = poweredByImage;
		} else if (poweredByImage === null || poweredByImage === undefined) {
			_poweredByImage = null;
		} else {
			throw new Error('invalid powered by image: ' + poweredByImage);
		}

		if (Util.isValidURL(privacyStatement)) {
			_privacyStatement = privacyStatement;
		}


		// public methods

		this.name = function () {
			return _name;
		};
		
		this.url = function () {
			return _url;
		};

		this.description = function () {
			return _description;
		};

		this.image = function () {
			return _image;
		};
		
		this.poweredByImage = function () {
			return _poweredByImage;
		};

		this.privacyStatement = function () {
			return _privacyStatement;
		};

		this.toObject = function () {
			return {
				name : _name,
				url : _url,
				description : _description,
				image : Util.serialize(_image),
				privacyStatement : _privacyStatement,
				poweredByImage: Util.serialize(_poweredByImage)
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/ProviderInfo.js
// module id = 141
// module chunks = 2